import { Icon } from "../ui/Icon";
import { type TableColumn, type TableRow, blankRow } from "../../lib/formTable";

/** Doldurmada tablo alanı: kolon-başlıklı satırlar; kullanıcı satır ekler/siler, her hücre kolon tipine göre input. */
export function TableFieldInput({ columns, rows, onChange }: { columns: TableColumn[]; rows: TableRow[]; onChange: (rows: TableRow[]) => void }) {
  const setCell = (ri: number, key: string, v: unknown) => onChange(rows.map((r, i) => (i === ri ? { ...r, [key]: v } : r)));
  const addRow = () => onChange([...rows, blankRow(columns)]);
  const removeRow = (ri: number) => onChange(rows.filter((_, i) => i !== ri));

  const cell = (c: TableColumn, val: unknown, set: (v: unknown) => void) => {
    const s = typeof val === "string" ? val : "";
    if (c.type === "boolean") return <input type="checkbox" checked={val === true} aria-label={c.label} onChange={(e) => set(e.target.checked)} />;
    if (c.type === "select") return (
      <select className="form-select" value={s} aria-label={c.label} onChange={(e) => set(e.target.value)}>
        <option value="">— Seç —</option>
        {c.options.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
    );
    return (
      <input
        className="form-input"
        type={c.type === "number" ? "number" : c.type === "date" ? "date" : "text"}
        step={c.type === "number" ? "any" : undefined}
        inputMode={c.type === "number" ? "decimal" : undefined}
        value={s}
        aria-label={c.label}
        onChange={(e) => set(e.target.value)}
      />
    );
  };

  return (
    <div className="ff-table-wrap">
      <div className="ff-table-scroll">
        <table className="ff-table">
          <thead>
            <tr>
              {columns.map((c) => <th key={c.key}>{c.label}{c.unit ? <span className="ff-table-unit"> ({c.unit})</span> : null}{c.required ? <span className="req"> *</span> : null}</th>)}
              <th className="ff-table-actcol" aria-label="İşlem"></th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td className="ff-table-empty" colSpan={columns.length + 1}>Henüz satır yok — “Satır ekle” ile başlayın.</td></tr>
            ) : rows.map((row, ri) => (
              <tr key={ri}>
                {columns.map((c) => <td key={c.key} className={c.type === "boolean" ? "c" : undefined}>{cell(c, row?.[c.key], (v) => setCell(ri, c.key, v))}</td>)}
                <td className="c"><button type="button" className="fb-iact danger" aria-label={`Satır ${ri + 1} sil`} title="Satırı sil" onClick={() => removeRow(ri)}><Icon name="trash" size={13} /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <button type="button" className="btn-md secondary" style={{ height: 32, padding: "0 12px", fontSize: 12.5, marginTop: 8 }} onClick={addRow}>
        <Icon name="plus" size={14} />Satır ekle
      </button>
    </div>
  );
}
